<template lang="pug">
    .featured-collection(
      v-if="featuredProducts.products"
    )
      .featured-collection__header
        h3.featured-collection__title(
          v-if="sectionTitle"
        ) {{ sectionTitle }}
        .featured-collection__pagination
          .featured-collection__pagination-arrow.featured-collection__pagination-arrow--left
            icon(
              name="long-arrow-left",
              size="32px"
            )
          .featured-collection__pagination-arrow.featured-collection__pagination-arrow--right
            icon(
              name="long-arrow-right",
              size="32px"
            )
      .featured-collection__sliders
        swiper(
          ref="featuredCollection"
          :options="swiperOptions"
        )
          swiper-slide(
            v-for="(product, index) in featuredProducts.products",
            :key="index"
          )
            product-tile(
              :product="product",
            )
</template>

<script>
  import Icon from 'scripts/components/basic/Icon.vue';
  import ProductTile from 'scripts/components/product/ProductTile.vue';
  import { swiper, swiperSlide } from 'vue-awesome-swiper';

  export default {
    name: 'FeaturedCollection',
    components: {
      Icon,
      ProductTile,
      swiper,
      swiperSlide,
    },
    props: {
      sectionTitle: String,
      featuredProducts: Object,
    },
    data() {
      return {
        swiperOptions: {
          loop: true,
          slidesPerView: 3,
          slidesPerGroup: 1,
          spaceBetween: 40,
          navigation: {
            nextEl: '.featured-collection__pagination-arrow--right',
            prevEl: '.featured-collection__pagination-arrow--left',
          },
          breakpoints: {
            768: {
              slidesPerView: 2,
              spaceBetween: 30,
            },
            640: {
              slidesPerView: 1.5,
              spaceBetween: 20,
            },
          },
        },
      };
    },
    computed: {
      swiper() {
        return this.$refs.featuredCollection.$swiper;
      },
    },
  };
</script>

<style scoped lang="scss">
  .featured-collection__header {
    display: flex;
    flex-wrap: wrap;
    padding-bottom: ($spacing-unit * 5);
  }

  .featured-collection__title {
    flex: 1;
    margin: 0;
    text-align: center;

    @include tablet-up {
      text-align: left;
    }
  }

  .featured-collection__pagination {
    display: none;

    @include tablet-up {
      display: flex;
    }
  }

  .featured-collection__pagination-arrow {
    display: flex;
    align-items: center;
    cursor: pointer;
  }

  .featured-collection__pagination-arrow--left {
    padding-right: ($spacing-unit * 2);
  }

  .featured-collection__pagination-arrow--right {
    padding-left: ($spacing-unit * 2);
  }
</style>
